<script>
  import { _ } from "$helpers/i18n.js";
  import { Accordion, DataTable } from "$lib";
  import { globalStore } from "../../store/globalStore.js";

  const isMobile = globalStore.isMobile;

  let activeIndex = null;
  let opens = {};

  function toggle(i) {
    if ($isMobile) {
      activeIndex = activeIndex === i ? null : i;
    } else {
      opens = { ...opens, [i]: !opens[i] };
    }
  }

  // Inicializamos las variables taxTableHeaders y taxTableRows, como variables reactivas, para que se actualicen cada vez que cambie el país seleccionado.
  $: taxTableHeaders = [
    $_('taxes.explanation.table.1_1_bold'),
    $_('taxes.explanation.table.1_2_bold'),
    $_('taxes.explanation.table.1_3_bold'),
    $_('taxes.explanation.table.1_4_bold'),
    $_('taxes.explanation.table.1_5_bold'),
    $_('taxes.explanation.table.1_6_bold'),
    $_('taxes.explanation.table.1_7_bold'),
  ];

  $: taxTableRows = [
    [$_('taxes.explanation.table.2_1'), $_('taxes.explanation.table.2_2'), $_('taxes.explanation.table.2_3'), $_('taxes.explanation.table.2_4'), $_('taxes.explanation.table.2_5'), $_('taxes.explanation.table.2_6'), $_('taxes.explanation.table.2_7')],
    [$_('taxes.explanation.table.3_1'), $_('taxes.explanation.table.3_2'), $_('taxes.explanation.table.3_3'), $_('taxes.explanation.table.3_4'), $_('taxes.explanation.table.3_5'), $_('taxes.explanation.table.3_6'), $_('taxes.explanation.table.3_7')],
    [$_('taxes.explanation.table.4_1'), $_('taxes.explanation.table.4_2'), $_('taxes.explanation.table.4_3'), $_('taxes.explanation.table.4_4'), $_('taxes.explanation.table.4_5'), $_('taxes.explanation.table.4_6'), $_('taxes.explanation.table.4_7')],
    [$_('taxes.explanation.table.5_1'), $_('taxes.explanation.table.5_2'), $_('taxes.explanation.table.5_3'), $_('taxes.explanation.table.5_4'), $_('taxes.explanation.table.5_5'), $_('taxes.explanation.table.5_6'), $_('taxes.explanation.table.5_7')],
  ];
</script>

<div class="explanation-container">
<!-- --------- ¿Para qué sirve? --------- -->
  <Accordion title={$_("explanation.title_1")} open={$isMobile ? activeIndex === 0 : !!opens[0]} onToggle={() => toggle(0)}>
  <div class="explanation-item">
    <p>{$_("taxes.explanation.paragraph_1")}</p>
    <p>{$_("taxes.explanation.paragraph_2")}</p>
    <ol>
      <li>{$_("taxes.explanation.item_1")}</li>
      <li>{$_("taxes.explanation.item_2")}</li>
    </ol>
    <p>
      {$_("taxes.explanation.paragraph_3_1")}
      <strong>{$_("taxes.explanation.paragraph_3_bold")}</strong>
      {$_("taxes.explanation.paragraph_3_2")}
      <strong>{$_("common.calculate_bold")}</strong>{$_("taxes.explanation.paragraph_3_3")}
    </p>
    <!-- Formula 1 -->
    <div class="formula">
      <span class="left">{$_("taxes.explanation.form_left_part")}</span>
      <span class="right">{$_("taxes.explanation.form_top_part")}</span>
    </div>
    <p>
      {$_("taxes.explanation.paragraph_4")}
      <strong>{$_("taxes.explanation.paragraph_4_bold")}</strong>
      {$_("taxes.explanation.paragraph_3_2")}
      <strong>{$_("common.calculate_bold")}</strong>{$_("taxes.explanation.paragraph_3_3")}
    </p>
    <!-- Formula 2 -->
    <div class="formula">
      <span class="left">{$_("taxes.explanation.form_left_part_2")}</span>
      <span class="frac">
        <span class="top">{$_("taxes.explanation.form_top_part_2")}</span>
        <span class="bottom">{$_("taxes.explanation.form_down_part")}</span>
      </span>
    </div>
  </div>
  </Accordion>
  <!-- --------- Conceptos Importantes --------- -->
  <Accordion title={$_("explanation.title_2")} open={$isMobile ? activeIndex === 1 : !!opens[1]} onToggle={() => toggle(1)}>
  <div class="explanation-item">
    <ul class="punteo-list">
      <li>
        {$_("explanation.important_concepts_common_1")}
        <strong>{$_("taxes.explanation.item_1_concepts_bold")}</strong>
        {$_("taxes.explanation.item_1_concepts")}
      </li>
      <li>
        {$_("explanation.important_concepts_common_1")}
        <strong>{$_("taxes.explanation.item_2_concepts_bold")}</strong>
        {$_("taxes.explanation.item_2_concepts")}
      </li>
      <li>
        {$_("explanation.important_concepts_common_2")}
        <strong>{$_("taxes.explanation.item_3_concepts_bold")}</strong>
        {$_("taxes.explanation.item_3_concepts")}
      </li>
      <li>
        {$_("explanation.important_concepts_common_1")}
        <strong>{$_("taxes.explanation.item_4_concepts_bold")}</strong>
        {$_("taxes.explanation.item_4_concepts")}
      </li>
      <li>
        {$_("taxes.explanation.item_5_concepts_1")}
        <strong>{$_("taxes.explanation.item_5_concepts_bold")}</strong>
        {$_("taxes.explanation.item_5_concepts_2")}
      </li>
    </ul>
  </div>
  </Accordion>
  <!-- --------- Factores a Considerar --------- -->
  <Accordion title={$_("explanation.title_3")} open={$isMobile ? activeIndex === 2 : !!opens[2]} onToggle={() => toggle(2)}>
  <div class="explanation-item">
    <p>{$_("taxes.explanation.paragraph_5")}</p>
    <ul class="punteo-list">
      <li>{$_("taxes.explanation.item_1_factors")}</li>
      <li>{$_("taxes.explanation.item_2_factors")}</li>
    </ul>
    <p>{$_("taxes.explanation.paragraph_6")}</p>
  </div>
  </Accordion>

  <!-- --------- Casos Prácticos --------- -->
  <Accordion title={$_("explanation.title_8")} open={$isMobile ? activeIndex === 3 : !!opens[3]} onToggle={() => toggle(3)}>
    <div class="explanation-item">
      <DataTable headers={taxTableHeaders} rows={taxTableRows} centerAlignColumns={[2, 3, 4, 5, 6]} columnWidths={["14%", "14%", "13%"]}/>
    </div>
  </Accordion>
</div>